/**
 * Format source name to be used as a label
 * @param {string} sourceName
 */
const formatSourceName = (sourceName) => sourceName?.split(/(?=[A-Z])/).join(' ') || '--';

export { formatSourceName };
